// extracted by mini-css-extract-plugin
module.exports = {"customChip":"OfferStatus_customChip__39q5I","customChipOptional":"OfferStatus_customChipOptional__2iHKy"};